import { 
    START_FETCHING,
    STOP_FETCHING,
    SET_IS_BANNED,
    SET_LANGUAGE,
    SET_RULES_ACCEPTED,
    UPDATE_MODS_COUNT,
    UPDATE_ACCOUNT,
    SIGN_IN,
    ACCESS_DATA,
    SIGN_UP,
    DOWNLOAD_ZIP,
    CHECK_FILE_SIZE,
    ZIP_IS_READY
} from "../actions/CurrentAccount"

const initialState = {
    initialized: true,
    isBanned: false,
    isFetching: false,
    isRulesAccepted: false,
    isUserStatisticsSufficient: false, // отвечает за соответствие аккаунта игрока для выкладывания модов на портале
    lang: null,
    realm: null,
    spaId: null,
    spaUsername: null,
    accessData: {},
    isErrorData: false,
    count: 0,
    notifications: [],
    tickets: {
        filterParams: {
            type: -1,
        },
        offset: 0,
        page: 1,
        isFetchedAll: false,
        
        reviewed: 0,
        answered: 0,
        count: 0,

        items: [],
    },
    ticketView: {
        filterParams: {
            type: -1,
        },
        modData: [],
        ticketId: 0,
        ownerId: null,
        isClose: false,
        ownerName: null,
        problemTypes: [],
        createdAt: null,
        count: 0,

        msg: []
    },
    updatedModsCount: 0,
    zipOriginalName: null, // for basket shop - file zip name
    zipSize: 0, // for basket shop - checkFileZip
    isZipReady: false, // for basket shop - zip is ready to download
}

export const currentAccount = (state = initialState, action) => {
    if (!state.initialized) {
        state = { ...initialState, ...state }
    }
    switch(action.type) {
        case START_FETCHING:
            return {
                ...state,
                isFetching: true,
            }
        case STOP_FETCHING:
            return {
                ...state,
                isFetching: false,
            }
        case SET_LANGUAGE:
            return {
                ...state,
                lang: action.code,
            }
        case SET_RULES_ACCEPTED:
            return {
                ...state,
                isRulesAccepted: true,
            }
        case UPDATE_MODS_COUNT:
            return {
                ...state,
                updatedModsCount: action.count,
            }
        case UPDATE_ACCOUNT:
            return {
                ...state,
                isUserStatisticsSufficient: action.payload.isUserStatisticsSufficient || false,
                count: action.payload.count || 0,
                notifications: action.payload.notifications || [],
                spaId: action.payload.spaId,
                spaUsername: action.payload.spaUsername,
            }
        case DOWNLOAD_ZIP:
            return {
                ...state,
                zipOriginalName: action.payload.zipOriginalName,
                zipSize: action.payload.zipSize,
            }
        case CHECK_FILE_SIZE:
            return {
                ...state,
                zipSize: action.payload.zipSize,
            }
        case ZIP_IS_READY:
            return {
                ...state,
                isZipReady: action.payload.isZipReady,
            }
        case SIGN_IN:
            return {
                ...state,
                isErrorData: action.payload.isErrorData,
            }
        case SIGN_UP:
            return {
                ...state,
                isErrorData: action.payload.isErrorData,
            }
        case ACCESS_DATA:
            return {
                ...state,
                accessKey: action.payload.accessKey,
                accessData: action.payload.accessData,
            }
        case SET_IS_BANNED:
            return {
                ...state,
                isBanned: true,
            }
        default:
            return state
    }
}